export const isArrowDown = (e) => e.keyCode === 40;
export const isArrowUp = (e) => e.keyCode === 38;
export const isEnter = (e) => e.keyCode === 13;
